<app-mini-loader *ngIf="loading"></app-mini-loader>
<app-error *ngIf="error"></app-error>
<app-colapsable [title]="'BENEFICIARIOS'" *ngIf="beneficiarios?.length > 0" ($expandedChange)="expandChange()">
  <div body>
    <app-table
      [theme]="1"
      [displayedColumns]="displayedColumns"
      [datasource]="beneficiarios"
      (iconClick$)="onIconClick($event)"
    ></app-table>
  </div>
</app-colapsable>
